import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { CountryDto } from '../../api/fetch-countries/fetchCountries.types';
import type { UseCountriesReturn } from './useCountries.types';

import { fetchCountries } from '../../api/fetch-countries/fetchCountries';

export function useCountries(): UseCountriesReturn {
  const { data = [], isLoading, isError } = useQuery<CountryDto[], Error>({
    queryKey: ['countries'],
    queryFn: fetchCountries,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const countries = useMemo(() => {
    const seen = new Map<string, CountryDto>();
    data.forEach(c => {
      if (!seen.has(c.iso2Code)) seen.set(c.iso2Code, c);
    });
    return Array.from(seen.values());
  }, [data]);

  return {
    countries,
    isCountriesLoading: isLoading,
    isCountriesError: isError,
  };
}
